<script>
    import {onMount} from 'svelte';
    import rpcjs from 'rpcjs';
    const {title, goto} = rpcjs.props;
    title.set('Our Team');
    onMount(animation, 10);
    let pro1;
    let pro2;
    let pro3;
    let heading;
    let frames;
    
/**
 */
    function animation() {
        setTimeout(start, 200);
    }
/**
 */
    function start() {
        heading.style.top = '1.8vw';
        pro1.style.bottom = '-8vw';
        pro2.style.bottom = '-8vw';
        pro3.style.bottom = '-8vw';
        heading.style.transition = '0.5s';
        pro1.style.transition = '0.5s';
        pro2.style.transition = '0.625s';
        pro3.style.transition = '0.625s';
    }
    /**
     * Adds two numbers together.
     */
    function next() {
        frames.style.left = '100vw';
        heading.style.opacity = '0';
        setTimeout(()=>{
            goto('/joinus');
        }, 800);
    }
    /**
     * Adds two numbers together.
     * @param {int} e The first number.
     */
    function keycheck(e) {
        e.preventDefault();
        if (e.key == 'ArrowRight') {
            next();
        }
        if (e.key == 'ArrowLeft') {
            goto('/moat');
        }
    }
</script>

<svelte:window on:keyup={keycheck}/>

<div class="maindiv" role="presentation" on:click={next}>
    <div class="ourteam">
        <div class="h1" style="opacity:1;" bind:this={heading}>OUR <span style="letter-spacing: -0.35vw;">TEAM</span></div>

        <div class="frames" bind:this={frames}>
            <div class="profile" bind:this={pro1}>
                <div class="profile_img">
                    <img id="profile" src="images/ourteam/adnan.svg" alt="" />
                    <div class="name_heading">
                        <div class="name">ADNAN YUNUS</div>
                        <div class="des">
                            Founder | CEO | Cheif Data Scientist
                        </div>
                    </div>
                </div>
                <div class="details">
                    <ul class="list">
                        <li class="text1">
                            Worked on software for Hubble telescope and F16 jets
                        </li>
                        <li class="text1">
                            Built real-time heterogeneous systems at GE and
                            Ericsson
                        </li>
                        <li class="text1">
                            Automated air defense systems for DARPA
                        </li>
                    </ul>

                    <div class="companies">
                        <div class="logo1">
                            <img
                                id="logo1"
                                src="images/ourteam/companies/img1.svg"
                                alt=""
                            />
                            <img
                                id="logo1"
                                src="images/ourteam/companies/img2.svg"
                                alt=""
                            />
                            <img
                                id="logo1"
                                src="images/ourteam/companies/img3.svg"
                                alt=""
                            />
                            <img
                                id="logo1"
                                src="images/ourteam/companies/img4.svg"
                                alt=""
                            />
                            <img style="left:0.5vw"
                                id="logo1"
                                src="images/ourteam/companies/img5.svg"
                                alt=""
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="profile" bind:this={pro2}>
                <div class="profile_img">
                    <img id="profile" src="images/ourteam/asra.png" alt="" />
                    <div class="name_heading">
                        <div class="name">ASRA NADEEM</div>
                        <div class="des">
                            Co-Founder | COO | Business Dev
                        </div>
                    </div>
                </div>
                <div class="details">
                    <ul class="list">
                        <li class="text1">
                            Built the first matchmaking service for Muslims and scaled it from 300 to 1.5M in 9 months
                        </li>
                        <li class="text1">
                            Led product and growth for the largest employment marketplace in Pakistan and KSA (investors: DJF, Reid Hoffman)"
                        </li>
                        <li class="text1">
                            First female Pakistani VC (3 unicorns in fund I)
                        </li>
                    </ul>

                    <div class="companies">
                        <div class="logo2">
                            <img
                                id="logo1"
                                src="images/ourteam/companies/img6.svg"
                                alt=""
                            />
                            <img
                                id="logo1"
                                src="images/ourteam/companies/img7.svg"
                                alt=""
                            />
                            <img
                                id="logo1"
                                src="images/ourteam/companies/img8.svg"
                                alt=""
                            />
                            <img
                                id="logo1"
                                src="images/ourteam/companies/img9.svg"
                                alt=""
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="profile" bind:this={pro3}>
                <div class="profile_img">
                    <img id="profile" src="images/ourteam/zaeem.svg" alt="" />
                    <div class="name_heading">
                        <div class="name">ZAEEM ZOQI</div>
                        <div class="des">
                            Head of Design & Creative
                        </div>
                    </div>
                </div>
                <div class="details">
                    <ul class="list">
                        <li class="text1">
                            Built and scaled experiences business across MENA catering to over 50,000 customers/year
                        </li>
                        <li class="text1">
                            Launched an automated pizza chain with 22 franchises in 2 years across MENA
                        </li>

                      
                        
                    </ul>

                    <div class="companies">
                        <div class="logo3">
                            <img
                                id="logo1"
                                src="images/ourteam/companies/img10.svg"
                                alt=""
                            />
                            <img
                                id="logo1"
                                src="images/ourteam/companies/img11.svg"
                                alt=""
                            />
                            <img
                                id="logo1"
                                src="images/ourteam/companies/img12.svg"
                                alt=""
                            />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<style>

    .companies{
        display: flex;
        flex-wrap: wrap;
        position: absolute;
        top: 8.5vw
    }
    .logo1, .logo2, .logo3{
        display: flex;
        position: absolute;
    }
    .logo3{
        gap: 2vw;
        left: 2vw;
    }

    .logo2, .logo3{
        gap:1vw;
    }
    #logo1 {
        height: 2vw;
        width: 4vw;
    }
    .maindiv {
        background-color: #010422;
        height: 100vh;
        width: 100vw;
    }
    .ourteam {
        font-family: "Montserrat";
    }
    .h1 {
        position: absolute;
        font-size: 5.208vw;
        font-weight: 900;
        letter-spacing: -0.045em;
        color: #ff007f;
        top: -10vw;
        left: 35.833vw;
    }
    .frames {
        position: absolute;
        display: flex;
        left: 0vw;
        transition-duration: 1s;
    }
    .profile {
        position: relative;
        bottom: -108vw;
        height:27.865vw;
        left: 6.083vw;
        width: 31vw;
        color: white;
        text-align: center;
    }
    .profile_img {
        height: 24.865vw;
        width: 21.448vw;
        border-radius: 2.083vw;
    }
    #profile {
        height: 100%;
        width: 100%;
    }
    .name_heading {
        position: absolute;
        top: 18vw;
        left: 3vw;
        text-align: left;
        line-height: 2.2vw;
    }
    .name {
        font-size: 1.83vw;
        font-weight: 900;
    }
    .des {
        font-size: 0.9vw;
        font-weight: 400;
    }
    .details {
        position: absolute;
        height: 8.438vw;
        width: 22vw;
        left: 1vw;
        top: 26vw;
    }
    .list {
        position: absolute;
        display: flex;
        flex-direction: column;
        padding: 0;
        margin: 0;
    }
    .text1{
        font-size: 0.833vw;
        font-weight: 400;
        line-height: 1.25vw;
        letter-spacing: -0.04vw;
        text-align: left;
    }
</style>
